import { Item__Finalidades } from "../../../../../../../../../services/atividades/GET";


export const dummy_atividades = [
    {cod: 1, nome: 'Plantio', titulo: 'ADUBAÇÃO PRÉ PLANTIO (KCL, S° e B)'},
    {cod: 2, nome: 'Plantio', titulo: 'DESSECAÇÃO'},
    {cod: 3, nome: 'Plantio', titulo: 'DESSECAÇÃO SEQUENCIAL + PRÉ EMERGENTE'},
    {cod: 4, nome: 'Plantio', titulo: 'PLANTIO, FERTILIZAÇÃO BASE, TS'},
    {cod: 5, nome: 'Plantio', titulo: 'HERBICIDA PÓS + NUTRIÇÃO'}
];

export const dummy_operacoes = [
    {cod: 100, nome: "Plantio"},
    {cod: 101, nome: "Pulverização"},
    {cod: 102, nome: "Preparo de solo"},
    {cod: 103, nome: "Fertilização"},
    {cod: 104, nome: "Correção de solo"},
    {cod: 105, nome: "Tratamento de semente"},
    {cod: 106, nome: "Colheita"},
    // {cod: 107, nome: "Outra"},
    {cod: 208, nome: "Coleta de solo"},
    {cod: 209, nome: "Aplicação de composto orgânico"},
    {cod: 210, nome: "Integração lavoura e pecuária"},
];

export const dummy_finalidades: Item__Finalidades[] = [
    {
        cod: 109,
        nome: "Plantio com fertilização",
        cod_tipo_geral: 108,
        create_time: "2024-08-14 14:17:02.262676",
        update_time: null,
        delete_time: null,
        ordem: 1,
        tipo_geral_nome: "Tipos de finalidade para atividades de campo"
    },
    {
        cod: 110,
        nome: "Plantio sem fertilização",
        cod_tipo_geral: 108,
        create_time: "2024-08-14 14:17:02.262676",
        update_time: null,
        delete_time: null,
        ordem: 1,
        tipo_geral_nome: "Tipos de finalidade para atividades de campo"
    },
    {
        cod: 111,
        nome: "Fungicida",
        cod_tipo_geral: 108,
        create_time: "2024-08-14 14:17:02.262676",
        update_time: null,
        delete_time: null,
        ordem: 1,
        tipo_geral_nome: "Tipos de finalidade para atividades de campo"
    },
    {
        cod: 112,
        nome: "Inseticida",
        cod_tipo_geral: 108,
        create_time: "2024-08-14 14:17:02.262676",
        update_time: null,
        delete_time: null,
        ordem: 1,
        tipo_geral_nome: "Tipos de finalidade para atividades de campo"
    },
    {
        cod: 113,
        nome: "Herbicida",
        cod_tipo_geral: 108,
        create_time: "2024-08-14 14:17:02.262676",
        update_time: null,
        delete_time: null,
        ordem: 1,
        tipo_geral_nome: "Tipos de finalidade para atividades de campo"
    },
    {
        cod: 114,
        nome: "Micronutrientes",
        cod_tipo_geral: 108,
        create_time: "2024-08-14 14:17:02.262676",
        update_time: null,
        delete_time: null,
        ordem: 1,
        tipo_geral_nome: "Tipos de finalidade para atividades de campo"
    },
    {
        cod: 115,
        nome: "Regulador hormonal",
        cod_tipo_geral: 108,
        create_time: "2024-08-14 14:17:02.262676",
        update_time: null,
        delete_time: null,
        ordem: 1,
        tipo_geral_nome: "Tipos de finalidade para atividades de campo"
    },
    {
        cod: 116,
        nome: "Maturador",
        cod_tipo_geral: 108,
        create_time: "2024-08-14 14:17:02.262676",
        update_time: null,
        delete_time: null,
        ordem: 1,
        tipo_geral_nome: "Tipos de finalidade para atividades de campo"
    },
    {
        cod: 117,
        nome: "Dessecação",
        cod_tipo_geral: 108,
        create_time: "2024-08-14 14:17:02.262676",
        update_time: null,
        delete_time: null,
        ordem: 1,
        tipo_geral_nome: "Tipos de finalidade para atividades de campo"
    },
    {
        cod: 118,
        nome: "Inoculação",
        cod_tipo_geral: 108,
        create_time: "2024-08-14 14:17:02.262676",
        update_time: null,
        delete_time: null,
        ordem: 1,
        tipo_geral_nome: "Tipos de finalidade para atividades de campo"
    },
    {
        cod: 119,
        nome: "Condicionador de solo",
        cod_tipo_geral: 108,
        create_time: "2024-08-14 14:17:02.262676",
        update_time: null,
        delete_time: null,
        ordem: 1,
        tipo_geral_nome: "Tipos de finalidade para atividades de campo"
    },
    {
        cod: 120,
        nome: "Biológicos",
        cod_tipo_geral: 108,
        create_time: "2024-08-14 14:17:02.262676",
        update_time: null,
        delete_time: null,
        ordem: 1,
        tipo_geral_nome: "Tipos de finalidade para atividades de campo"
    },
    {
        cod: 121,
        nome: "Gradagem",
        cod_tipo_geral: 108,
        create_time: "2024-08-14 14:17:02.262676",
        update_time: null,
        delete_time: null,
        ordem: 1,
        tipo_geral_nome: "Tipos de finalidade para atividades de campo"
    },
    {
        cod: 122,
        nome: "Nivelação",
        cod_tipo_geral: 108,
        create_time: "2024-08-14 14:17:02.262676",
        update_time: null,
        delete_time: null,
        ordem: 1,
        tipo_geral_nome: "Tipos de finalidade para atividades de campo"
    },
    {
        cod: 123,
        nome: "Plaina",
        cod_tipo_geral: 108,
        create_time: "2024-08-14 14:17:02.262676",
        update_time: null,
        delete_time: null,
        ordem: 1,
        tipo_geral_nome: "Tipos de finalidade para atividades de campo"
    },
]

export const dummy_tipos_uso = [
    {cod: 1, nome: 'GERAL'},
    {cod: 2, nome: 'SEMENTE (VARIEDADE/HÍBRIDO)'},
    {cod: 3, nome: 'FERTILIZANTE'},
    {cod: 4, nome: 'TRATAMENTO SEMENTE'},
    {cod: 5, nome: 'ADJUVANTE'},
    {cod: 6, nome: 'CALCÁRIO'},
    // {cod: 7, nome: 'GESSO'},
    {cod: 8, nome: 'INOCULANTE'},
    {cod: 9, nome: 'BIOLÓGICO'},
];